<template>
  <v-row dense class="flex-grow-1">
    <v-col sm="4" class="d-flex">
      <div class="stat-item sm">
        <span class="value">{{
          balanceProceed.onlineProceedToday | amountWithCurrency0
        }}</span>
        <span>Онлайн</span>
      </div>
    </v-col>
    <v-col sm="4" class="d-flex">
      <div class="stat-item sm">
        <span class="value">{{
          balanceProceed.cashProceedToday | amountWithCurrency0
        }}</span>
        <span>Наличные</span>
      </div>
    </v-col>
    <v-col sm="4" class="d-flex">
      <div class="stat-item sm">
        <span class="value">{{
          balanceProceed.terminalProceedToday | amountWithCurrency0
        }}</span>
        <span>Терминал</span>
      </div>
    </v-col>
  </v-row>
</template>

<script>
  export default {
    name: 'RevenueSourcesList',
    props: {
      balanceProceed: Object,
    },
  }
</script>

<style scoped lang="less">
.stat-item {
  flex-grow: 1;

  .value {
    color: #6bad00;
  }
}
</style>
